import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');

import ActiveTagTableRow from './ActiveTagTableRow';

const propTypes = {
    className: PropTypes.string,
    tags: PropTypes.array,
    orgIntegrationTags: PropTypes.array.isRequired,
};

const defaultProps = {
    className: '',
    tags: [],
};

function TagTable(props) {
    const sortedTags = sortBy(props.tags, t => t.tag.toLowerCase());

    return (
        <ul className={`tagTable--heightConstrained ${props.className}`}>
            {sortedTags.map(activeTagRecord => {
                const tagRecord = props.orgIntegrationTags.find(t => t.tag === activeTagRecord.tag);
                return (
                    <ActiveTagTableRow
                        key={tagRecord.id}
                        tagRecord={tagRecord}
                        readOnly
                    />
                );
            })}
            {sortedTags.length === 0 &&
                <li className="tagRow" key="none-found">
                    <div /> {/*first col spacing*/}
                    <em className="font-style-italic">
                        No tags in use
                    </em>
                </li>
            }
        </ul>
    );
}

TagTable.propTypes = propTypes;
TagTable.defaultProps = defaultProps;

export default TagTable;